<template>
    <div class="container">
      <div class="d-flex justify-content-center">
        <div
          :key="photokey"
          class="col-md-3 text-center"
          style="background-color: antiquewhite; cursor: pointer;"
          
        >
          <!-- Affiche le logo depuis le store : logo_url (nouveau) ou logo (ancien) -->
          <img
            v-if="$store.getters.pharmacie && ($store.getters.pharmacie.logo_url || $store.getters.pharmacie.logo)"
            :src="$store.getters.pharmacie.logo_url || $store.getters.pharmacie.logo"
            alt="logo"
            id="logo"
            class="rounded mb-3 border"
            style="width: 200px; height: 200px;"
          >
          <p>Votre logo (500x500)</p>
          <input
              id="mylogo"
              name="mylogo"
              type="file"
              class="form-control"
              @change="handleFileUpload"
              accept="image/*"
            >
        </div>
      </div>
  
      <form @submit.prevent="saveCompanyInfo">
        <p class="h5">Enregistrer les informations de la pharmacie.</p>
  
        <div class="form-row">
          <!-- Input fichier caché pour le logo -->
          <div class="form-group col-md-4" hidden>
            <label for="mylogo">Select Photo:</label>
            <input
              id="mylogo"
              name="mylogo"
              type="file"
              class="form-control"
              @change="handleFileUpload"
              accept="image/*"
            >
          </div>
  
          <!-- nom_pharmacie -->
          <div class="form-group col-md-4">
            <label>Nom:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.nom_pharmacie"
              required
            >
          </div>
  
          <!-- adresse -->
          <div class="form-group col-md-4">
            <label>Adresse:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.adresse"
              required
            >
          </div>
  
          <!-- bp -->
          <div class="form-group col-md-4">
            <label for="">Boite Postale:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.bp"
            >
          </div>
  
          <!-- capital -->
          <div class="form-group col-md-4">
            <label for="">Capital:</label>
            <input
              type="number"
              class="form-control"
              v-model.number="formData.capital"
            >
          </div>
  
          <!-- statut_juridique -->
          <div class="form-group col-md-4">
            <label>Statut juridique:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.statut_juridique"
            >
          </div>
  
          <!-- rccm -->
          <div class="form-group col-md-4">
            <label for="">RCCM:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.rccm"
            >
          </div>
  
          <!-- nif -->
          <div class="form-group col-md-4">
            <label for="">NIF:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.nif"
            >
          </div>
  
          <!-- telephone1 -->
          <div class="form-group col-md-4">
            <label for="">Tel 1:</label>
            <input
              type="tel"
              class="form-control"
              v-model="formData.telephone1"
              required
            >
          </div>
  
          <!-- telephone2 (pas WhatsApp) -->
          <div class="form-group col-md-4">
            <label for="">Tel 2:</label>
            <input
              type="tel"
              class="form-control"
              v-model="formData.telephone2"
            >
          </div>
  
          <!-- email -->
          <div class="form-group col-md-4">
            <label>Email:</label>
            <input
              type="email"
              class="form-control"
              v-model="formData.email"
            >
          </div>
  
          <!-- site_web -->
          <div class="form-group col-md-4">
            <label for="">Site web:</label>
            <input
              type="text"
              class="form-control"
              v-model="formData.site_web"
            >
          </div>
  
          <!-- devise -->
          <div class="form-group col-md-4">
            <label for="">Devise:</label>
            <div>
              <select
                class="form-control"
                v-model="formData.devise"
              >
                <option value="FCFA">FCFA</option>
                <option value="USD">Dollar Americain</option>
              </select>
            </div>
          </div>
        </div>
  
        <!-- slogan -->
        <div class="form-group ">
          <label for="slogan">Slogan</label>
          <input
            id="slogan"
            type="text"
            class="form-control"
            v-model="formData.slogan"
          >
          <small>Affichage sous les tickets de caisse</small>
        </div>
  
        <p class="h5 my-3">Enregistrer les informations de votre environnement.</p>
  
        <div class="form-row">
          <!-- tva -->
          <div class="form-group col-md-4">
            <label>TVA:</label>
            <input
              type="number"
              step="any"
              placeholder="ex : 0.18"
              class="form-control"
              v-model.number="formData.tva"
              required
            >
          </div>
  
          <!-- css (corrigé, ce n’est plus v-model sur tva) -->
          <div class="form-group col-md-4">
            <label>CSS:</label>
            <input
              type="number"
              step="any"
              placeholder="ex : 0.10"
              class="form-control"
              v-model.number="formData.css"
            >
          </div>
        </div>
  
        <button type="submit" class="btn btn-bleu2 text-right">
          Enregistrer
          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
      </form>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue';
  import store from '../../../store';
  
  type Nullable<T> = T | null;
  
  /**
   * Interface correspondant aux colonnes de la base (ancien schéma)
   * + quelques champs dérivés (logo, logo_url).
   */
  interface PharmacyForm {
    nom_pharmacie?: string;
    adresse?: string;
    bp?: string;
    capital?: number | null;
    statut_juridique?: string;
    rccm?: string;
    nif?: string;
    telephone1?: string;
    telephone2?: string;
    email?: string;
    site_web?: string;
    devise?: string;
    slogan?: string;
    tva?: number | null;
    css?: number | null;
    logo?: string;      // ancien champ logo
    logo_url?: string;  // nouvelle URL du logo (retournée par l’API)
  }
  
  export default defineComponent({
    name: 'InfosPharmacie',
  
    emits: ['saved'],
  
    data() {
      return {
        isLoading: false as boolean,
        logo: null as Nullable<File>, // fichier logo sélectionné
        photokey: 1 as number,
      };
    },
  
    computed: {
      /**
       * formData est directement relié au store :
       *  - getter : lit this.$store.getters.pharmacie
       *  - setter : commit 'setPharmacieDatas'
       *
       * On peut donc utiliser v-model="formData.xxx"
       */
      formData: {
        get(): PharmacyForm {
          return (store.getters.pharmacie || {}) as PharmacyForm;
        },
        set(value: PharmacyForm) {
          store.commit('setPharmacieDatas', value);
        },
      },
    },
  
    methods: {

  
      /**
       * Récupère le fichier logo sélectionné.
       */
      handleFileUpload(event: Event): void {
        const target = event.target as HTMLInputElement;
        const files = target.files;
        if (files && files[0]) {
          this.logo = files[0];
        }
      },
  
      /**
       * Enregistre les informations de la pharmacie :
       * - Upload du logo sur /api/v1/pharmacy/logo si un fichier est sélectionné
       * - Enregistrement des infos sur /api/pharmacie-info (ancien endpoint)
       */
      async saveCompanyInfo(): Promise<void> {
        this.isLoading = true;
  
        try {
          const self: any = this as any; // pour accéder à this.axios / this.$toast sans se battre avec TS
  
          const form: any = {
            nom_pharmacie: this.formData.nom_pharmacie,
            adresse: this.formData.adresse,
            bp: this.formData.bp,
            capital: this.formData.capital,
            statut_juridique: this.formData.statut_juridique,
            rccm: this.formData.rccm,
            nif: this.formData.nif,
            telephone1: this.formData.telephone1,
            telephone2: this.formData.telephone2,
            email: this.formData.email,
            site_web: this.formData.site_web,
            devise: this.formData.devise,
            slogan: this.formData.slogan,
            tva: this.formData.tva,
            css: this.formData.css,
          };
  
          // 1️⃣ Upload du logo via le nouveau endpoint
          if (this.logo) {
            const fd = new FormData();
            fd.append('logo', this.logo);
  
            const logoResponse = await self.axios.post('/api/pharmacie/logo', fd, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
  
            if (logoResponse.data?.success && logoResponse.data?.data?.logo_url) {
              const url = logoResponse.data.data.logo_url;
  
              // On met à jour le store avec la nouvelle URL de logo
              this.formData = {
                ...this.formData,
                logo_url: url,
              };
  
              // On envoie aussi cette URL à l’ancien endpoint
              form.logo_url = url;
            }
          } else if (this.formData.logo_url) {
            // Si on a déjà un logo_url, on le renvoie pour rester cohérent
            form.logo_url = this.formData.logo_url;
          }
  
          // 2️⃣ Enregistrement des paramètres via l’ancien endpoint
          const response = await this.axios.post('/api/pharmacie-info', form, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
  
          this.isLoading = false;
  
          if (response.data.success === true) {
            self.$toast?.add({
              severity: 'success',
              detail: response.data.message,
              life: 3000,
            });
  
            // On met à jour le store avec les nouvelles valeurs renvoyées (si l’API renvoie les données)
            if (response.data.data) {
              this.formData = {
                ...this.formData,
                ...(response.data.data as PharmacyForm),
              };
            }
  
            // On prévient la page parent qu’on a fini
            this.$emit('saved');
          } else {
            // Gestion des erreurs renvoyées sous forme de tableau
            if (Array.isArray(response.data.errors)) {
              response.data.errors.forEach((element: string) => {
                self.$toast?.add({
                  severity: 'warn',
                  summary: 'Oups !',
                  detail: element,
                  life: 7000,
                });
              });
            } else {
              self.$toast?.add({
                severity: 'warn',
                summary: 'Oups !',
                detail: 'Erreur de validation',
                life: 7000,
              });
            }
          }
        } catch (error) {
          this.isLoading = false;
  
          (this as any).$toast?.add({
            severity: 'error',
            summary: 'Problème de connexion',
            detail: 'Une erreur s’est produite lors de la connexion au serveur !',
            life: 5000,
          });
        }
      },
    },
  });
  </script>
  